@for (measure of measures; track measure; let i = $index) {
  @if (shouldShowMeasure(measure)) {
    <div class="measure-item">
      <div style="margin-right: auto;">
        <cs-input-measure style="max-width: fit-content" (canonValueChange)="updateMeasure(measure)"
          [readonly]="isReadOnly" [(canonValue)]="measure.amount" type="food_fraction">
        </cs-input-measure>
      </div>
      <div class="name-picker">
        @if (lockToPreparedMeasure) {
          <!-- a recipe's one measure is structural: its name is always 'prepared' and the
               number beside it is how many servings the recipe makes. There is nothing to
               choose, so the name is fixed text. It used to be a picker, and changing it
               deleted the measure and the servings count with it (#4380). -->
          <span class="fixed-name">{{ preparedMeasureLabel }}</span>
        } @else {
          <cs-item>
            <!-- [ariaLabel] names the picker: the row around it holds the amount and weight
                 inputs, so there is no row text this select can take its name from -->
            <cs-select [ariaLabel]="LL.editFood.labels.measureName()"
              [placeholder]="LL.common.placeholders.selectMeasure()" [disabled]="isReadOnly"
              [(value)]="measure.name" (valueChange)="updateMeasure(measure)">
              <!-- the select's [value] stays the raw canonical measure name (persisted and
                   compared elsewhere, e.g. measure.name === 'prepared'); only [label] is
                   translated, via measureLabel() -- see its comment in the .ts file -->
              @for (m of searchItems; track m) {
                <cs-select-option [value]="m" [label]="measureLabel(m)"></cs-select-option>
              }
            </cs-select>
          </cs-item>
        }
      </div>
      <div>
        <cs-input-measure (canonValueChange)="updateMeasure(measure)"
          [readonly]="measure.name === 'prepared' || isReadOnly" type="foodweight_g" [(canonValue)]="measure.weight_g">
        </cs-input-measure>
        @if (hasMeasureWeightWarning(measure)) {
          <span class="measure-weight-warning">{{ LL.editFood.errors.measureWeightRequired() }}</span>
        }
      </div>
      <div>
        @if (measure.name !== 'prepared') {
          <cs-input-measure (canonValueChange)="updateMeasure(measure)"
            [readonly]="isReadOnly" type="food_volume" [(canonValue)]="measure.volume_ml">
          </cs-input-measure>
        }
      </div>
      @if (!isReadOnly) {
        <div class="delete-button-container">
          @if (measure.name !== 'prepared') {
            <cs-icon name="remove-circle"
            class="delete-icon" (click)="removeMeasure(measure)"></cs-icon>
          } @else {
            <cs-icon name="remove-circle" class="delete-icon" style="visibility: hidden;"></cs-icon>
          }
        </div>
      }
    </div>
  }
}

@if (!isReadOnly && !lockToPreparedMeasure) {
  <div class="add-button-container">
    <cs-button tertiary icon="add" [label]="LL.editFood.buttons.addServingSize()"
    (click)="addMeasure()"></cs-button>
  </div>
}
